import dayjs from "dayjs";

export const LESSON_TYPE_VIDEO = 1;
export const LESSON_RECORD_FREE_ACCESS_DAYS = 7;

export function isLessonRecordLocked({ lesson, isPremium, now = dayjs() }) {
    if (!lesson) {
        return false;
    }

    if (Number(lesson.type) === LESSON_TYPE_VIDEO) {
        return false;
    }

    if (isPremium) {
        return false;
    }

    return now.isAfter(dayjs(lesson.date).add(LESSON_RECORD_FREE_ACCESS_DAYS, "day"), "day");
}

export function lessonRecordDaysRemaining({ lesson, now = dayjs() }) {
    return Math.max(
        0,
        dayjs(lesson.date).add(LESSON_RECORD_FREE_ACCESS_DAYS, "day").diff(now, "day"),
    );
}
